/* Presentation only: Shopify Forms retains its inputs, validation and submission. */
(() => {
  if (customElements.get('mxw-newsletter')) return;
  const sheets = new Map();
  const loadSheet = url => {
    if (!sheets.has(url)) sheets.set(url, fetch(url)
      .then(response => { if (!response.ok) throw new Error('Styles unavailable'); return response.text(); })
      .then(css => { const sheet = new CSSStyleSheet(); sheet.replaceSync(css); return sheet; })
      .catch(() => null));
    return sheets.get(url);
  };
  customElements.define('mxw-newsletter', class extends HTMLElement {
    connectedCallback() {
      if (this.watching) return;
      this.watching = true;
      this.roots = new Map();
      this.observer = new MutationObserver(() => this.scan());
      this.observer.observe(this, {childList:true, subtree:true});
      loadSheet(this.dataset.styles).then(sheet => {
        if (!this.isConnected || !sheet) return;
        this.sheet = sheet;
        this.scan();
      });
      customElements.whenDefined('shopify-forms-embed').then(() => {
        if (this.isConnected) this.scan();
      });
    }
    scan() {
      if (!this.sheet) return;
      for (const host of this.querySelectorAll('[data-forms-id="forms-root-1191405"] shopify-forms-embed')) {
        const root = host.shadowRoot;
        if (!root || this.roots.has(host) || !('adoptedStyleSheets' in root)) continue;
        // A local, removable stylesheet; never replace app markup or event handlers.
        try { root.adoptedStyleSheets = [...root.adoptedStyleSheets, this.sheet]; }
        catch { continue; } // Unsupported browsers keep the normal working app layout.
        const update = () => {
          const form = root.querySelector('#form-container-ref form[data-testid="form"]');
          const email = form?.querySelector('input[inputmode="email"]');
          const button = form?.querySelector('button[type="submit"][data-testid="btn-form-submit"]');
          const field = email?.parentElement;
          // Shopify adds a headless Shop proxy after its SDK loads, even with Shop
          // login disabled. Keep that proxy intact without treating it as a field.
          const headlessProxy = child => child.tagName === 'DIV' && child.children.length === 1 &&
            !!child.querySelector(':scope > shop-lead-capture[proxy="true"]:not([button-type])');
          // Only compact the known email-only form. Extra fields/Shop/consent controls
          // automatically retain Shopify's full layout instead of being hidden.
          const compact = !!(form && field?.parentElement === form && button?.parentElement === form &&
            field.querySelector('label') && [...form.children].every(child =>
              child === field || child === button || child.matches('output,[role="alert"],[hidden],div:empty') || headlessProxy(child)));
          host.toggleAttribute('data-mx-compact', compact);
          host.toggleAttribute('data-mx-hero', !!this.closest('.hero--scroll'));
          if (compact && !email.getAttribute('placeholder')) email.setAttribute('placeholder', 'Enter your email address');
        };
        const observer = new MutationObserver(update);
        observer.observe(root, {childList:true, subtree:true, attributes:true, attributeFilter:['data-current-step','button-type','proxy']});
        this.roots.set(host, observer);
        update();
      }
      for (const [host, observer] of this.roots) {
        if (!this.contains(host)) { observer.disconnect(); this.roots.delete(host); }
      }
    }
    disconnectedCallback() {
      this.watching = false;
      this.observer?.disconnect();
      for (const [host, observer] of this.roots || []) {
        observer.disconnect();
        host.removeAttribute('data-mx-compact');
        host.removeAttribute('data-mx-hero');
        if (host.shadowRoot) host.shadowRoot.adoptedStyleSheets = host.shadowRoot.adoptedStyleSheets.filter(sheet => sheet !== this.sheet);
      }
      this.roots?.clear();
    }
  });
})();
